import {Button, Stack} from "react-bootstrap";
import {ColumnizeText, OurClearAlert, PageTitle, SingleText} from "../../_components";
import React from "react";
import {Link, useNavigate, useParams} from "react-router-dom";
import {useAuth} from "../../../context";
import {useGetJson, usePostJson} from "../../../hooks";
import {endpoints} from "../../../utils2";
import {Formik, Form as FormikForm} from "formik";
import * as yup from "yup";
import {WhiteCard} from "../../device/_components/WhiteCard";
import {centsToString, unitsToCents} from "../admin/utilities/formatCurrency";
import {SetDateField} from "../../_components/SetDateField";


export function AddEditDiscount() {
    const {did} = useParams()
    const {authToken} = useAuth()
    const navigate = useNavigate();

    const edit = did !== "add"

    const [dDet, loadingDDetails, errorDDetails, clearErrorDDetails] = useGetJson(did === "add" ? null : endpoints.discount.get(did), authToken?.jwt)
    const discountDetails = dDet?.data

    const [submitFormAdd, _, loadingAdd, errorAdd, clearErrorAdd] = usePostJson(endpoints.discount.add(), authToken?.jwt)

    const [submitFormEdit, _2, loadingEdit, errorEdit, clearErrorEdit] = usePostJson(endpoints.discount.edit(did), authToken?.jwt)

    const loading = loadingAdd || loadingEdit || loadingDDetails

    const validationSchema = yup.object().shape({
        code: yup.string().required("Code is required"),
        discount_in_cents: yup.number().typeError("Discount must be a number").required(),
        valid_from: yup.date().required(),
        valid_to: yup.date().required(),
        min_cart_in_cents: yup.number().typeError("Min cart must be a number").required(),
        max_discount_use: yup.number().typeError("Max discount use must be a number").required()
    })

    const initialValues = {
        code: discountDetails?.code || "",
        discount_in_cents: edit ? centsToString(discountDetails?.discount_in_cents) : "",
        valid_from: edit ? new Date(discountDetails?.valid_from || null).toISOString().split("T")[0] : new Date().toISOString().split("T")[0],
        valid_to: edit ? new Date(discountDetails?.valid_to || null).toISOString().split("T")[0] : new Date().toISOString().split("T")[0],
        min_cart_in_cents: edit ? centsToString(discountDetails?.min_cart_in_cents) : "",
        max_discount_use: discountDetails?.max_discount_use || "",
    }

    function handleSubmit(values, action) {
        const convertedValues = {...values, discount_in_cents: unitsToCents(values.discount_in_cents), min_cart_in_cents: unitsToCents(values.min_cart_in_cents)}

        if (edit) {
            submitFormEdit(convertedValues, jsonTime => {
                action.setSubmitting(false)
                navigate(-1)
            })
        } else {
            submitFormAdd(convertedValues, jsonTime => {
                action.setSubmitting(false)
                navigate(-1)
            })
        }
    }

    return <Stack>
        <OurClearAlert variant="danger" msg={errorDDetails} onClear={clearErrorDDetails}/>
        <OurClearAlert variant="danger" msg={errorAdd} onClear={clearErrorAdd}/>
        <OurClearAlert variant="danger" msg={errorEdit} onClear={clearErrorEdit}/>

        <PageTitle title="Discount Details">{edit ? "Edit" : "Add"} discount.</PageTitle>

        {loading && <div>Loading...</div>}

        <Formik validationSchema={validationSchema} onSubmit={handleSubmit} initialValues={initialValues} enableReinitialize={true} validateOnChange={true}>
            {({isSubmitting, resetForm}) => (
                <FormikForm>

                    <WhiteCard>
                        <ColumnizeText>
                            <SingleText name="code" label="Code" placeholder="AltraBits5"/>
                            <SingleText name="discount_in_cents" label="Discount" prefix="€" className=""/>
                        </ColumnizeText>
                    </WhiteCard>

                    <WhiteCard>
                        <ColumnizeText>
                            <SingleText name="min_cart_in_cents" label="Min Cart Total" prefix="€" className="" tip="Set to 0 to disable minimum cart total"/>
                            <SingleText name="max_discount_use" label="Max Discount Use" className=""/>
                        </ColumnizeText>

                        <div className="text-capitalize text-body-secondary mt-2">Set validity range</div>
                        <Stack direction="horizontal" gap={2} className="my-2">
                            <SetDateField name="valid_from"/>
                            <SetDateField name="valid_to"/>
                        </Stack>
                    </WhiteCard>

                    <Stack direction="horizontal" gap="2" className="py-3 justify-content-end">
                        <Button as={Link} variant="link" to={-1}>Go back</Button>
                        <Button type="reset" variant="secondary" onClick={resetForm}>Reset</Button>
                        <Button type="submit" variant="primary" disabled={isSubmitting}>Save</Button>
                    </Stack>

                </FormikForm>
            )}
        </Formik>
    </Stack>
}
